import { Link, useLocation, Navigate } from 'react-router-dom'
import { useResendVerification } from '../hooks/useResendVerification'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const CheckEmailPage = () => {
  const location = useLocation()
  const email = (location.state as { email?: string })?.email

  const { mutate: resend, isPending, isSuccess } = useResendVerification()

  if (!email) {
    return <Navigate to="/register" replace />
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md space-y-4">
        <div className="flex justify-center">
          <img src="/vectorFP3Logo.svg" alt="FP3 Finance" className="h-24" />
        </div>
        <Card>
          <CardHeader>
            <CardTitle data-testid="auth-check-email-heading">Check your email</CardTitle>
            <CardDescription>
              We sent a verification link to <strong>{email}</strong>
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Click the link in the email to verify your account. The link expires in 24 hours.
            </p>
            {isSuccess ? (
              <p className="text-sm text-success">Verification email resent.</p>
            ) : (
              <Button
                variant="outline"
                className="w-full"
                onClick={() => resend(email)}
                disabled={isPending}
              >
                {isPending ? 'Sending...' : 'Resend verification email'}
              </Button>
            )}
          </CardContent>
        </Card>
        <p className="text-center text-sm text-muted-foreground">
          Already verified?{' '}
          <Link to="/login" className="text-primary hover:underline font-medium">
            Log in
          </Link>
        </p>
      </div>
    </div>
  )
}
